export interface Settings {
  _id: string;
  general: {
    siteName: string;
    defaultLanguage: string;
    country: {
      code: string;
      label: string;
    };
    isMaintenanceMode: boolean;
    enableRegistration: boolean;
  };
  notifications: {
    emailEnabled: boolean;
    smsEnabled: boolean;
  };
  security: {
    passwordPolicy: {
      minLength: number;
      requireNumbers: boolean;
      requireSpecialCharacters: boolean;
    };
    maxLoginAttempts: number;
    lockoutDurationMinutes: number;
  };
  menus: {
    passportMenu: Array<{
      title: string;
      isVisible: boolean;
      order: number;
      _id: string;
    }>;
  };
  forms: {
    patientRecord: {
      administrativeDatas: {
        ediatableFields: string[];
        contacts: {
          canAdd: boolean;
          canModify: boolean;
          canDelete: boolean;
        };
      };
    };
  };
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface SettingsState {
  settings: Settings | null;
  loading: boolean;
  error: string | null;
}

export const initialSettingsState: SettingsState = {
  settings: null,
  loading: false,
  error: null,
};
